import { create } from "../../../common/utils/zustand_state_manager";
import { IObrasRepository } from "../../../features/obras/domain/repositories/obras_repository";
import { ObrasRepository } from "../../../features/obras/data/repositories/obras_repository";
import { useObrasServices } from "./use_services";

/**
 * useObrasRepositories
 */

type State = {
  obrasRepository: IObrasRepository,
};

export const useObrasRepositories = create<State>((set, get) => {
  const { obrasService } = useObrasServices.getState();
  return ({
    obrasRepository: new ObrasRepository(obrasService),
  });
});